import { useEffect, useState } from "react";
import api from "../../../utils/axiosInstance";
import { toast } from "../../../components/Toast/toast";
import Button from "../../../components/Button/Button";
import { Section, Card } from "../../admin/Settings/Account/accountParts";
import { AGREEMENT_PROSE } from "../../../components/Agreement/AgreementModal";

const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : "—");

const VendorAgreementPage = () => {
  const [agreement, setAgreement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    api
      .get("/vendor-agreement")
      .then((res) => setAgreement(res.data.data))
      .catch((err) => setError(err.response?.data?.message || "Failed to load the vendor agreement."))
      .finally(() => setLoading(false));
  }, []);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const res = await api.get("/vendor-agreement/download", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = "Vendor-Agreement.pdf";
      link.click();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not download the vendor agreement.");
    } finally {
      setDownloading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <div className="h-8 w-8 animate-spin rounded-full border border-gray-300 border-t-brand-600" />
      </div>
    );
  }

  if (error) return <p className="text-sm text-danger-600">{error}</p>;

  return (
    <Section
      title="Vendor Agreement"
      large
      actions={
        agreement.can_download && (
          <Button size="sm" onClick={handleDownload} disabled={downloading}>
            {downloading ? "Downloading..." : "Download PDF"}
          </Button>
        )
      }
    >
      <Card className="space-y-4">
        <div className="grid grid-cols-1 gap-x-8 gap-y-2 text-sm md:grid-cols-2">
          <p>
            <span className="text-xs font-medium text-gray-500">Last Updated At: </span>
            {formatDateTime(agreement.updated_at)}
          </p>
          <p>
            <span className="text-xs font-medium text-gray-500">Accepted On: </span>
            {formatDateTime(agreement.accepted_at)}
            {agreement.pending && agreement.accepted_at && (
              <span className="ml-2 rounded-full bg-warning-50 px-2 py-0.5 text-[11px] font-semibold text-warning-700">
                Earlier version
              </span>
            )}
          </p>
          {agreement.url && (
            <p className="md:col-span-2">
              <span className="text-xs font-medium text-gray-500">URL: </span>
              <a href={agreement.url} target="_blank" rel="noreferrer" className="break-all text-brand-600 hover:underline">
                {agreement.url}
              </a>
            </p>
          )}
        </div>

        <article className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-6 sm:px-8">
          <div className="mx-auto max-w-3xl rounded-xl border border-gray-200 bg-white px-6 py-7 shadow-sm sm:px-10 sm:py-9">
            <div className={AGREEMENT_PROSE} dangerouslySetInnerHTML={{ __html: agreement.text }} />
          </div>
        </article>
      </Card>
    </Section>
  );
};

export default VendorAgreementPage;
